import React, { memo } from 'react'
import { Grid2, Stack } from '@mui/material'

import FilterMenu from '../shared/filterMenu/FilterMenu'

import ChangePersonalInfo from './ChangePersonalInfo'
import ChangeEmailAddress from './ChangeEmailAddress'
import ChangePassword from './ChangePassword'
import AccountNumber from './AccountNumber'
import DisplayEmailAddress from './DisplayEmailAddress'
import { SOCIAL_MEDIA } from '../../constants/app'
import ChangeCountry from './ChangeCountry'
import { SETTING_FILTER_TYPE } from '../../util/settings.helpers'
import MoreInformationWrapper from 'wrappers/MoreInformationWrapper'
import LoadingSkeleton from './LoadingSkeleton'
import ManageAccountsContainer from '../../containers/ManageAccountsContainer'
import PageTitle from '../shared/pageTitle/PageTitle'
import { ACCOUNT_CHANGE_ACTION } from '../../constants/auth'

const UserAccount = ({
  accountProfile,
  dispatchAction,
  updatePersonalInfo,
  changeEmailAddress,
  changePassword,
  changeCountry,
  onCopyAccountNumber,
  signedUpVia,
  t,
  tabOptions,
  filterBy,
  onChangeFilterMenu,
  authAction
}) => {
  const pageTitle = t('navigation.settings')
  const renderTabData = () => {
    if (accountProfile.loading) {
      return <LoadingSkeleton />
    }
    switch (filterBy) {
      case SETTING_FILTER_TYPE.GENERAL:
        return (
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <AccountNumber
                accountProfile={accountProfile}
                onCopyAccountNumber={onCopyAccountNumber}
                t={t}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 8 }}>
              <Stack spacing={3}>
                <ChangePersonalInfo
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={updatePersonalInfo}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.PERSONAL_INFO}
                />
                <ChangeCountry
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changeCountry}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.COUNTRY}
                />
              </Stack>
            </Grid2>
          </Grid2>
        )

      case SETTING_FILTER_TYPE.CONNECTED_ACCOUNTS:
        return <ManageAccountsContainer />

      case SETTING_FILTER_TYPE.SECURITY:
        return (
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12, md: 6 }}>
              {signedUpVia === SOCIAL_MEDIA.GOOGLE ? (
                <DisplayEmailAddress
                  email={accountProfile.email}
                  signedUpVia={signedUpVia}
                  t={t}
                />
              ) : (
                <ChangeEmailAddress
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changeEmailAddress}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.EMAIL}
                />
              )}
            </Grid2>
            {!signedUpVia && (
              <Grid2 size={{ xs: 12, md: 6 }}>
                <ChangePassword
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changePassword}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.PASSWORD}
                />
              </Grid2>
            )}
            <Grid2 size={{ xs: 12, md: 6 }}>
              <MoreInformationWrapper t={t} />
            </Grid2>
          </Grid2>
        )

      default:
        return null
    }
  }
  return (
    <>
      <PageTitle title={pageTitle} />
      <FilterMenu
        value={filterBy}
        options={tabOptions}
        onChange={onChangeFilterMenu}
      />
      {renderTabData()}
    </>
  )
}

export default memo(UserAccount)
